export const NON_CLICKABLE = 'non-clickable'
export const ABBREVIATED = 'abbreviated'
export const TEAMS_NOTIFICATIONS = 'teams-notifications'
export const REMOVABLE = 'removable'
export const CLICKABLE = 'clickable'
